export const GET_ADMIN_DASH_REQUEST = 'GET_ADMIN_DASH_REQUEST';
export const GET_ADMIN_DASH_SUCCESS = 'GET_ADMIN_DASH_SUCCESS';
export const GET_ADMIN_DASH_FAILURE = 'GET_ADMIN_DASH_FAILURE';
export const PATCH_WORKFLOW_STATE_REQUEST = 'PATCH_WORKFLOW_STATE_REQUEST';
export const PATCH_WORKFLOW_STATE_SUCCESS = 'PATCH_WORKFLOW_STATE_SUCCESS';
export const PATCH_WORKFLOW_STATE_FAILURE = 'PATCH_WORKFLOW_STATE_FAILURE';
export const GET_SENT_EMAIL_ADMIN_REQUEST = 'GET_SENT_EMAIL_ADMIN_REQUEST';
export const GET_SENT_EMAIL_ADMIN_SUCCESS = 'GET_SENT_EMAIL_ADMIN_SUCCESS';
export const GET_SENT_EMAIL_ADMIN_FAILURE = 'GET_SENT_EMAIL_ADMIN_FAILURE';
